import React from 'react'

function DescAlert(props) {
    return (
        <>
            <div className="background">
                <div className="box text-white" title="Project Description Box">
                    <label htmlFor="" onClick={()=>props.closeButton()} title="Close the Alert">X</label>
                    <h2><u>{props.title}</u></h2>
                    <small className="text-warning">Project Description :</small>
                    <p>{props.desc}</p>
                    <p>Technologies used : {props.tecUsed}</p>
                    {props.type==="react"?
                    <p>Concepts Used : {props.conUsed}</p>
                    :null}
                </div>
            </div>
        </>
    )
}

export default DescAlert
